<template>
    <div class="mk__date flex">
      <span class="mk-current__table">{{$t('mc.calendar.today')}}, {{today}}</span>
      <div class="mk__datepicker flex">
        <div class="mk__date-period">
          <span class="mk__date-text mk__date-start">{{$t('mc.calendar.dateMcStart')}}</span>
          <datepicker
            calendar-class="my-datepicker_calendar"
            class="datepicker_mimk"
            :clearable="false"
            v-model="date.start"
            @change="searchByDate"
            format="DD.MM.YYYY"
            valueType="format"
            :lang="globalSettingCalendar">
            <i slot="icon-calendar">
              <inline-svg :src="require(`@/assets/svg/picker-calendar.svg`)"/>  
            </i>
          </datepicker>
        </div>
        <div class="mk__date-period">
          <span class="mk__date-text mk__date-end">{{$t('mc.calendar.dateMcFinish')}}</span>
          <datepicker
            class="datepicker_mimk"
            :clearable="false"
            v-model="date.finish"
            @change="searchByDate"
            format="DD.MM.YYYY"
            valueType="format"
            :lang="globalSettingCalendar">
            <i slot="icon-calendar">
              <inline-svg :src="require(`@/assets/svg/picker-calendar.svg`)"/>  
            </i>
          </datepicker>
        </div>
      </div>
    </div>
</template>

<script>
import globalSettingCalendar from '@/helpers/globalSettingCalendar'
export default {
  data() {
    return {
      globalSettingCalendar,
      date: {
        start: '',
        finish: ''
      }
    }
  },
  created() {
    this.date.start = this.$dayjs(new Date()).format('DD.MM.YYYY')
    this.date.finish = this.$dayjs(new Date()).format('DD.MM.YYYY')
    this.$emit('searchByDate', this.date)
  },
  methods: {
    searchByDate() {
      let dayDifference = this.$dayjs(this.date.finish, 'DD.MM.YYYY').diff(this.$dayjs(this.date.start, 'DD.MM.YYYY'), 'day')
      if (dayDifference < 0) {
        this.date.start = this.date.finish
        this.$toasted.global.all_mistake(this.$t('mc.toasts.errorDatePeriod'))
        return
      }
      this.$emit('searchByDate', this.date)
    }
  },
  computed: {
    today() {
      return this.$dayjs(new Date()).format('D MMMM')
    },
  }
}
</script>

<style lang="scss" scoped>
.mk {
  &-future__title {
    margin-top: 40px;
  }
  &__date{
    justify-content: space-between;
  }
  &__date-text {
    margin-right: 15px;
    font-weight: 500;
  }
  &__date-end {
    margin-left: 15px;
  }
}
</style>